import React from 'react';
import styles from './ProfilePageSkeleton.module.css';

const ProfilePageSkeleton = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.profilePic}></div>
                <div className={styles.userInfo}>
                    <div className={styles.name}></div>
                    <div className={styles.username}></div>
                    <div className={styles.bio}></div>
                    <div className={styles.stats}>
                         <div className={styles.stat}></div>
                         <div className={styles.stat}></div>
                         <div className={styles.stat}></div>
                         <div className={styles.stat}></div>
                    </div>
                </div>
            </div>
            
            <div className={styles.sectionTitle}></div>
            <div className={styles.grid}>
                 <div className={styles.card}></div>
                 <div className={styles.card}></div>
                 <div className={styles.card}></div>
            </div>

            <div className={styles.sectionTitle}></div>
            <div className={styles.grid}>
                 <div className={styles.card}></div>
                 <div className={styles.card}></div>
            </div>
        </div>
    );
};

export default ProfilePageSkeleton;
